import React from "react";

import lightBulb from '../children-home/images-home/AboutUs2.jpg'

const Confirmation = () => {

  return(
    <div className="confirmationPage">
      <div className="left">
        <h1>Thank You!</h1>
        <h2>An Invoice has been sent to your Email</h2>
        <h3>The invoice is good for 7 days.</h3>
        <h3>
          Once the payment has been received, please allow up to 2
          business days for a confirmation email.
        </h3>
        <h3>
          For any questions or concerns, please 
          email <a href="mailto:sales@simpleindy.com">sales@simpleindy.com</a>
        </h3>
      </div>
      <div className="right">
        <img src={lightBulb} alt="green light bulb"/>
        <h2>Making our Home Greener</h2>
      </div>
    </div>
  )
}

export default Confirmation;